var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"feather feather-chevron-down",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":_vm.color,"stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polyline',{attrs:{"points":"6 9 12 15 18 9"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }